export default {
  getAccessories: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/accessories/getters.js